import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { VariantAccessoryPacks } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.VariantAccessoryPacks = VariantAccessoryPacks;
// CLR alias: PortableComponent.cshtml renders VariantAccessoryPack blocks via this component.
global.VariantAccessoryPack = VariantAccessoryPacks;
